import axiosInstance from "./Axios";

export class BrandApi {
  static uploadBrandLogo = async (brandId: string, data: FormData) => {
    try {
      const res = await axiosInstance.post(
        `/admin/brand/${brandId}/logo`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static updateBrandLogo = async (brandId: string, data: FormData) => {
    try {
      const res = await axiosInstance.post(
        `/admin/brand/${brandId}/logo`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getBrandById = async (brandId: string) => {
    try {
      const res = await axiosInstance.get(`/admin/brand/${brandId}`);

      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to fetch brand data",
        data: err?.response?.data,
      };
    }
  };

  static updateBrandDetails = async (brandId: string, data: any) => {
    try {
      const res = await axiosInstance.put(`/admin/brand/${brandId}`, data);

      return {
        success: true,
        data: res.data,
      };
    } catch (err: any) {
      return {
        success: false,
        error:
          err?.response?.data?.message ||
          "Something went wrong while updating brand!",
        data: err?.response?.data,
      };
    }
  };

    static getBrandSettings = async (brandId: string) => {
    try {
      const res = await axiosInstance.get(
        `/admin/brand/brand_settings/${brandId}`,
      );
      return {
        success: true,
        data: res.data?.data,
      };
    } catch (err: any) {
      return {
        success: false,
        error:
          err?.response?.data?.message ||
          "Something went wrong while fetching brand settings!",
        data: err?.response?.data,
      };
    }
  };
}
